import React from "react";
import Slider from "react-slick";
import Navbar from "../../../layout/Navbar";
import Footer from "../../../layout/Footer";
import AcidProofMortarImage from "../../../assets/Our Products/Mortar/Acid Proof Mortar/ACID-PROOF-MORTAR.jpg";
import Slider1 from "../../../assets/Our Products/MonolithicCastable/slider/70-MORTAR.jpg";
import Slider2 from "../../../assets/Our Products/MonolithicCastable/slider/ACID-PROOF-MORTAR.jpg";
import Slider3 from "../../../assets/Our Products/MonolithicCastable/slider/FIRE-CLAY.jpg";
import Slider4 from "../../../assets/Our Products/MonolithicCastable/slider/HEAT-A.jpeg";
import Slider5 from "../../../assets/Our Products/MonolithicCastable/slider/HEAT-C.jpeg";
import Slider6 from "../../../assets/Our Products/MonolithicCastable/slider/HEAT-K.jpeg";
import Slider7 from "../../../assets/Our Products/MonolithicCastable/slider/IS-8-MORTAR.jpg";
import Slider8 from "../../../assets/Our Products/MonolithicCastable/slider/LCC-60.jpg";
import Slider9 from "../../../assets/Our Products/MonolithicCastable/slider/LCC-90.jpg";
import Slider10 from "../../../assets/Our Products/MonolithicCastable/slider/LEE-CAST-SUPER.jpeg";
import Slider11 from "../../../assets/Our Products/MonolithicCastable/slider/NEW-LEE-11.jpg";
import Slider12 from "../../../assets/Our Products/MonolithicCastable/slider/NEW-LEE-7.jpg";
import Slider13 from "../../../assets/Our Products/MonolithicCastable/slider/NEW-LEE-SUPER.jpg";
import Slider14 from "../../../assets/Our Products/MonolithicCastable/slider/RAMMING-MASS.jpg";
import Slider15 from "../../../assets/Our Products/MonolithicCastable/slider/THERMOTEX.png";
import Slider16 from "../../../assets/Our Products/MonolithicCastable/slider/new-lee-50.jpg";


const ACID_Proof_Mortar = () => {

  const sliderImages = [
    Slider1, Slider2, Slider3, Slider4, Slider5, Slider6, Slider7, Slider8, Slider9, Slider10, Slider11, Slider12, Slider13, Slider14, Slider15, Slider16
  ];

  // Responsive slider settings
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* About Fire Clay Bricks Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
          {/* Text Section */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About <span className="text-orange-600">Acid Proof Mortar</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              Furan Mortar is a two-part chemical setting Furan base mortar used for bonding acid resistant bricks and tiles. It is impermeable in texture and resistant to a very wide range of chemicals, including strong acids alkalis, oils, solvents and unaffected by temperature up to 170 C. Furan mortar “C” a 100 % carbon filled mortar is available where resistant to Hydrofluoric acid, fluoride salts and strong hot alkalis are required.
            </p>
          </div>

          {/* Image Section */}
          <div className="flex justify-center md:justify-end relative">
            <img
              src={AcidProofMortarImage}
              alt="Acid Proof Mortar"
              className="w-80 h-80 object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* Auto Image Slider Section */}
      <section className="py-8 sm:py-16 bg-[#0b032d] text-white relative overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="relative flex justify-center overflow-hidden rounded-2xl">

            <div className="slider w-full sm:w-2/3 h-[260px] sm:h-[250px]">
              <div className="w-full">
                <Slider {...sliderSettings}>
                  {sliderImages.map((image, index) => (
                    <div key={index} className="px-2 sm:px-2">
                      <img
                        src={image}
                        alt={`Slide ${index + 1}`}
                        className="h-[260px] sm:h-[200px] lg:h-[250px] w-full object-contain rounded-lg shadow-md"
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>

          </div>
        </div>
      </section>


      <style jsx>{`
        @keyframes slide {
          0% { transform: translateX(0); }
          33% { transform: translateX(-260px); }
          66% { transform: translateX(-520px); }
          100% { transform: translateX(0); }
        }
        .animate-slide {
          animation: slide 8s infinite linear;
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default ACID_Proof_Mortar;
